// extracted by mini-css-extract-plugin
export default {"highlightContainer":"FormattedText_highlightContainer__G5E+m","code":"FormattedText_code__gGkEP","lineClamp1":"FormattedText_lineClamp1__cYclw"};